/**
 * @module shared/payment-card
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const ONLINE_PAYMENT = {
  SUPPORTED: 'Supported',
  CARD_TYPE_HYBRID: 'Hybrid',
  CARD_TYPE_CREDIT: 'Credit',
  ANON: 'ANON',
  CARE: 'care',
  DEBIT_CARD: 'Debit',
  DEBIT: 'debit',
  TEMP_CARD_TYPE: 'tempCardType',
  INVALID: 'invalid',
  TRANSACTION_TYPE: 'ACTIVATION',
  INDIVIDUAL: 'INDIVIDUAL',
  PAYMENT_METHOD_NAME: 'storedPayments',
  PREPAID: 'PREPAID',
  sPREPAID: 'Prepaid',
  COUNTRY: 'Country',
  AUTOPAY: 'autopay',
  CARD_ON_NEGATIVE_FILE:
    'We are unable to verify the card details provided. Please re-enter the card number or try a different card to continue.',
};

export const MAX_LIMIT_MODAL = {
  BUTTON_ID: 'button1',
  BUTTON_TYPE: 'submit',
  BUTTON_CLASS: 'btn btn-primary',
};

export const AUTOPAY_ORDER_TYPE_CONSTANTS = {
  MANAGERATEPLAN: 'MANAGERATEPLAN',
  ACTIVATION: 'ACTIVATION',
  ADDALINE: 'ADDALINE',
  MANAGEADDON: 'MANAGEADDON',
};
